import { createDropdownOptions } from 'src/helpers/formHelpers'
import { usePortfolioManagers, useProgramManagers, useContractVehicles } from 'src/queries'

export interface UseLookupsReturn {
  portfolioManagers: ReturnType<typeof createDropdownOptions>
  programManagers: ReturnType<typeof useProgramManagers>
  contractVehicles: ReturnType<typeof useContractVehicles>
}

const useLookups = (): UseLookupsReturn => {
  const portfolioManagers = usePortfolioManagers()
  const programManagers = useProgramManagers()
  const contractVehicles = useContractVehicles()
  return {
    portfolioManagers,
    programManagers,
    contractVehicles
  }
}

export default useLookups
